(function () {

    'use strict';

    angular
        .module('app.layout')
        .controller('LayoutController', [
            'APP_CONFIG',
            '$route',
            '$routeParams',
            '$location',
            '$scope',
            'ApiService',
            'DataService',
            'CommonUtil',
            'GaService',
            '$anchorScroll',
            '$timeout',
            LayoutController
        ]);

    function LayoutController(APP_CONFIG, $route, $routeParams, $location, $scope, apiService, dataService, commonUtil, gaService, $anchorScroll, $timeout) {

        var vm = this;

        var allLocationsNoHome = undefined;
        var staticAllocations;

        $scope.getLocalization = getLocalization;
        $scope.getLanguage = getLanguage;
        $scope.getLocation = getLocation;
        $scope.getAllLocationsNoHome = getAllLocationsNoHome;
        $scope.getRootUrl = getRootUrl;
        $scope.getRootUrlNoFrontHash = getRootUrlNoFrontHash;
        $scope.isDefaultLocation = isDefaultLocation;
        $scope.isErrorPage = isErrorPage;
        $scope.gotoAnchor = gotoAnchor;

        init();

        function init() {
            $scope.$on('$routeChangeSuccess', function (event, current, previous) {
                if (angular.isUndefined(current) || !!current.isErrorPage
                		|| angular.isUndefined(current.originalPath)
                		|| current.originalPath === '' || current.originalPath === '/') {
                    return;
                }

                if (angular.isDefined(previous) && angular.isDefined(previous.loadedTemplateUrl)
                    && previous.loadedTemplateUrl.indexOf('VehicleDetails.html') >= 0) {
                	angular.element('.zoomContainer').remove();
                	angular.element('.lightbox').remove();
                	angular.element('.lightboxOverlay').remove();
                }

                apiService.getLanguages().then(function (response) {
                    var defaultLangCode = getDefaultLanguageCode(current.pathParams.locCode, response.data);
                    if (angular.isUndefined(defaultLangCode)) {
                        $location.path('/loc/' + APP_CONFIG.DEFAULT_HOME);
                        return;
                    } else {
                        var selectedLanguage = apiService.getLanguageByCode(response.data, current.pathParams.langCode);
                        if (angular.isUndefined(selectedLanguage)) {
                            var languageList = [dataService.getLanguageCodeFromCookie(), defaultLangCode];
                            selectedLanguage = commonUtil.getDisplayLanguageFromCodeList(response.data, languageList);
                            $location.path('/loc/' + current.pathParams.locCode + '/lang/' + selectedLanguage.languageCode + '/');
                            return;
                        }
                    }
                    $scope.$broadcast('layoutInitSuccess');
                    $timeout(function() {
                        gotoAnchor();
                    }, 0);

                    vm.printMode = !!current.printMode;
                    dataService.setCurrentLanguage(selectedLanguage);
                    apiService.getLocations(selectedLanguage.languageCode).then(function (response) {
                        var selectedLocation = apiService.getLocationByCode(response.data, current.pathParams.locCode);
                        dataService.setCurrentLocation(selectedLocation);

                        allLocationsNoHome = [];
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].locationCode !== APP_CONFIG.DEFAULT_HOME) {
                                allLocationsNoHome.push(response.data[i]);
                            }
                        }
                        apiService.getStaticLocations(selectedLanguage.languageCode).then(function(res) {
                            staticAllocations = res.data;
                            allLocationsNoHome = allLocationsNoHome.concat(staticAllocations);
                            vm.allLocationsNoHome = allLocationsNoHome;
                        });

                        vm.pageTitle = selectedLocation.locationWindowTittle;
                    });
                    apiService.getTranslationByCode(selectedLanguage.languageCode).then(function (response) {
                        dataService.setCurrentTranslation(response.data);
                    });
                });
            });

            gaService.gaLoadScript();
        }

        function getLocation() {
            return dataService.getCurrentLocation();
        }

        function getAllLocationsNoHome() {
            return allLocationsNoHome;
        }

        function getLanguage() {
            return dataService.getCurrentLanguage();
        }

        function getLocalization() {
            return dataService.getCurrentTranslation();
        }

        function getRootUrl() {
            return commonUtil.getLocationUrl(dataService.getCurrentLocation(), dataService.getCurrentLanguage(), false, false);
        }

        function getRootUrlNoFrontHash() {
            return commonUtil.getLocationUrl(dataService.getCurrentLocation(), dataService.getCurrentLanguage(), false, true);
        }

        function isDefaultLocation() {
            return $routeParams.locCode === APP_CONFIG.DEFAULT_HOME;
        }

        function isErrorPage() {
        	return !!$route.current.isErrorPage;
        }

        function getDefaultLanguageCode(locCode, languages) {
            var defaultLangCode = undefined;
            if (angular.isDefined(locCode) && angular.isArray(languages)) {
                for (var i = 0; i < languages.length; i++) {
                    var locations = languages[i].defaultLanguagesForlocationCodes;
                    if (angular.isArray(locations)) {
                        for (var j = 0; j < locations.length; j++) {
                            if (locations[j] === locCode) {
                                defaultLangCode = languages[i].languageCode;
                                break;
                            }
                        }
                    }
                }
            }
            return defaultLangCode;
        }

        function gotoAnchor(id) {
            $anchorScroll(id);
        }
    }

})();



// WEBPACK FOOTER //
// ./app/layout/LayoutController.js